import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { VehicleFeature } from '@hyundai/ng-common-lib';
import { IttCartItem } from '@hyundai/shared-lib';
import { M000C030CheckoutWrapperComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';
import DistributionOverviewStepComponent from './distribution-overview-step/distribution-overview-step.component';
import DistributionReceiptComponent from './distribution-receipt/distribution-receipt.component';
import DistributionThanksStepComponent from './distribution-thanks-step/distribution-thanks-step.component';

@Component({
    standalone: true,
    templateUrl: './distribution-page.component.html',
    imports: [
        M000C030CheckoutWrapperComponent,
        DistributionThanksStepComponent,
        DistributionOverviewStepComponent,
        DistributionReceiptComponent,
    ],
    selector: 'lib-distribution-page',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export default class DistributionPageComponent {
    store = inject(Store);
    vehicle = this.store.selectSignal(VehicleFeature.vehicleState.selectLoadedDetail);
    isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    accessories = computed(() => {
        // get cart items from session storage if platformIsBrowser

        if (this.isBrowser) {
            const cart = sessionStorage.getItem('cart');

            if (cart) {
                const cartItems = JSON.parse(cart) ?? [];
                return cartItems.map((item: IttCartItem) => {
                    return `${item.name} (${item.articleNumber}) ${item.price.value} ${item.price.currency}`;
                });
            }
        }

        return [];
    });
}
